<div class="payment-container">
  <div class="payment-card">
    @switch (status) {
      @case ('LOADING') {
        <div class="status-content">
          <div class="spinner"></div>
          <h2>Betaling verwerken</h2>
          <p>Een ogenblik geduld, we controleren de status van je abonnement...</p>
        </div>
      }

      @case ('SUCCESS') {
        <div class="status-content success">
          <div class="icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M20 6L9 17l-5-5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h2>Gefeliciteerd! 🎉</h2>
          <p>Je abonnement is succesvol geactiveerd. Je hebt nu direct toegang tot alle extra functionaliteiten.</p>
          <button class="btn btn-primary" (click)="goToDashboard()">Naar Dashboard</button>
        </div>
      }

      @case ('PENDING') {
        <div class="status-content pending">
          <div class="icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
          </div>
          <h2>Betaling ontvangen</h2>
          <p>We wachten nog op de definitieve verwerking door Stripe. Dit duurt meestal hooguit een paar seconden.</p>
          <button class="btn btn-primary" (click)="goToDashboard()">Naar Dashboard</button>
        </div>
      }

      @case ('CANCELLED') {
        <div class="status-content cancelled">
          <div class="icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <line x1="18" y1="6" x2="6" y2="18" stroke-linecap="round"/>
              <line x1="6" y1="6" x2="18" y2="18" stroke-linecap="round"/>
            </svg>
          </div>
          <h2>Betaling geannuleerd</h2>
          <p>Je betaling is niet afgerond. Er is niets afgeschreven en je kunt het op elk moment opnieuw proberen.</p>
          <button class="btn btn-secondary" (click)="goToAccount()">Back to account</button>
        </div>
      }

      @case ('ERROR') {
        <div class="status-content error">
          <div class="icon-circle">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
          </div>
          <h2>Status niet bevestigd</h2>
          <p>We konden de status niet direct verifiëren. Controleer je accountinstellingen of neem contact op als het bedrag wel is afgeschreven.</p>
          <button class="btn btn-secondary" (click)="goToDashboard()">Naar Dashboard</button>
        </div>
      }
    }
  </div>
</div>